// extracted by mini-css-extract-plugin
module.exports = {"percentInput":"src-components-PercentInput-styles___percentInput"};